import elt from "../html/elt";
import injectCSS from "../html/inject-css";

export class LabeledColorChip extends HTMLElement {

    img?: HTMLImageElement;
    imgContainer: HTMLElement;

    _src?: string;
    _tint?: string;

    constructor() {
        super();
        injectCSS(STYLESHEET);

        this.imgContainer = elt('div', {class: 'labeled-color-chip-img-container'});
    }

    connectedCallback() {
        const content = this.innerText;
        this.replaceChildren();
        this.append(
            this.imgContainer,
            elt('label', {}, content)
        );
    }

    static observedAttributes = ["src", "tint"];

    attributeChangedCallback(name: string, _oldValue: string, newValue: string) {
        switch(name) {
            case "src":
                this.src = newValue;
                break;
            case "tint":
                this.tint = newValue;
                break;
        }
    }

    get src(): string | null {
        return this._src;
    }

    set src(value: string | null) {
        this._src = value;
        this.update();
    }

    get tint(): string | null {
        return this._tint;
    }

    set tint(value: string | null) {
        this._tint = value;
        this.update();
    }

    update() {
        if(this._src) {
            if(this.img) {
                this.img.src = this._src;
            } else {
                this.img = elt('img', { src: this._src });
                this.imgContainer.append(this.img);
            }
        } else { 
            if(this.img) {
                this.img.remove();
            }
        }
        if(this._tint) {
            this.imgContainer.style.backgroundColor = this._tint;
        } else {
            this.imgContainer.style.backgroundColor = '';
        }
    }

}
export default LabeledColorChip;
window.customElements.define('labeled-color-chip', LabeledColorChip);

const STYLESHEET = `
labeled-color-chip {
    display: block;
    text-align: center;
    padding: 0.5rem;

    cursor: pointer;

    border-color: var(--bs-border-color);
    border-width: var(--bs-border-width);
    border-style: var(--bs-border-style);
    border-radius: var(--bs-border-radius);

    & .labeled-color-chip-img-container {
        display: block;
        width: 3rem;
        height: 3rem;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 0.5rem;

        border: 1px solid black;

        background-color: white;

        & img {
            mix-blend-mode: multiply;
            width: 100%;
            height: 100%;
        }
    }
}
`;
